import Swiper from 'swiper/dist/js/swiper.min';
import Vue from 'vue';
import PopupFullscreen from '../../new-blocks/popup/fullscreen/popup-fullscreen';
import AnimationFade from '../../core/animation/fade/animation-fade';

export default function () {
  const facing = document.querySelectorAll('.block-tabs');

  if (facing && facing.length) {
    [].slice.call(facing).forEach((elem) => {
      const object = JSON.parse(elem.getAttribute('data-content'));
      new Vue({
        el: elem,
        delimiters: ['${', '}}'],
        components: {
          AnimationFade,
          PopupFullscreen,
        },
        data() {
          return {
            facingSection: object,
            isMobile: window.innerWidth < 1280,
            mainSlider: null,
            thumbSlider: null,
            thumb: null,
            main: null,
            optionsMain: null,
            optionsThumb: null,
            activeTabs: null,
            popupFullOpen: false,
            tabs: null,
            facing: null,
            sliders: [],
            fullscreenCards: [],
            fullscreenActive: 0,
            description: '',
            currentIndex: 0,
            selectedIndex: null,
            activeTabButton: null,
          };
        },
        mounted() {
          this.facing = this.$refs.facing;

          window.addEventListener('resize', () => {
            this.isMobile = window.innerWidth < 1280;
          });

          this.sliders = [].slice.call(this.facing.querySelectorAll('.block-tabs__tab'));
          this.selectTab(0);
          // if (this.facing) {
          //   this.tabArrows = [].slice.call(this.facing.querySelectorAll('.block-tabs__tabs-button'));
          //   this.tabBtns = [].slice.call(this.facing.querySelectorAll('.block-tabs__tab-btn'));
          //   if (!this.facingSection.isAside && this.$refs.inlineTabs) {
          //     this.$refs.inlineTabs.classList.add('facing-section__tabs--top');
          //   }
          // }
        },
        computed: {
          isFirst() {
            return this.selectedIndex === 0;
          },
          isLast() {
            return this.selectedIndex === this.lastIndex;
          },
          tabsCount() {
            return this.facingSection.tabs.length;
          },
          lastIndex() {
            return this.tabsCount - 1;
          },
        },
        methods: {
          changeTabs(btn, index) {
            this.tabBtns.forEach(tmp => tmp.classList.remove('facing-section__tab-btn--active'));
            this.sliders.forEach(tmp => tmp.classList.remove('facing-section__tab--active'));
            this.sliders[index].classList.add('facing-section__tab--active');
            this.description = this.facingSection.tabs[index].description;
            btn.classList.add('facing-section__tab-btn--active');
            this.slidersInit(this.sliders[index], index);
          },
          selectTab(index) {
            this.selectedIndex = index;
            // setTimeout(() => {
            //   this.slidersInit(this.sliders[index], index);
            // }, 500);
          },
          nextTab() {
            const index = this.isLast ? 0 : this.selectedIndex + 1;
            this.selectTab(index);
          },
          prevTab() {
            const index = this.isFirst ? this.lastIndex : this.selectedIndex - 1;
            this.selectTab(index);
          },

          slidersInit(tab, num) {
            const mainSlider = tab.querySelector('.block-tabs__main-slider');
            this.thumbSlider = tab.querySelector('.block-tabs__thumb-slider');
            let sliderCounter = tab.querySelector('.sliderButtons__counter');

            this.thumb = new Swiper(this.thumbSlider, {
              slidesPerView: 'auto',
              freeMode: true,
              watchSlidesVisibility: true,
              watchSlidesProgress: true,
              preloadImages: false,
              lazy: true,
              resistance: true,
              resistanceRatio: 0,
              spaceBetween: 14,
              breakpoints: {
                767: {
                  spaceBetween: 7,
                },
              },
            });

            this.fullscreenCards = [];

            this.facingSection.tabs[num].slider.forEach((slide) => {
              this.fullscreenCards.push(slide);
            });

            const thumbs = this.thumb;

            const options = {
              slidesPerView: 'auto',
              loop: false,
              navigation: {
                nextEl: '.sliderButtons__btn--next',
                prevEl: '.sliderButtons__btn--prev',
              },
              thumbs: {
                swiper: thumbs,
              },
              on: {
                init() {
                  sliderCounter = this.el.querySelector('.sliderButtons__counter');
                  if (sliderCounter) {
                    sliderCounter.querySelector('[data-name=activeSlide]').textContent = this.realIndex + 1;
                    sliderCounter.querySelector('[data-name=slidesLength]').textContent = this.slides.length - 2;
                  }
                  if (this.slides.length <= 1) {
                    if (this.el.querySelector('.block-tabs__slider-btns')) {
                      // this.el.querySelector('.block-tabs__slider-btns').style.display = 'none';
                      // this.el.nextElementSibling.style.display = 'none';
                    }
                  } else {
                    // this.el.nextElementSibling.style.display = 'block';
                  }
                  if (thumbs !== undefined) {
                    const slides = [].slice.call(thumbs.slides);
                    if (slides && slides.length) {
                      slides.forEach(tmp => tmp.classList.remove('facing-section__thumb-slide--active'));
                      slides[this.realIndex].classList.add('facing-section__thumb-slide--active');
                    }
                    thumbs.slideTo(this.realIndex);
                  }
                },
                slideChange() {
                  sliderCounter = this.el.querySelector('.sliderButtons__counter');
                  if (sliderCounter) {
                    sliderCounter.querySelector('[data-name=activeSlide]').textContent = this.realIndex + 1;
                  }
                  if (thumbs !== undefined) {
                    const slides = [].slice.call(thumbs.slides);
                    slides.forEach(tmp => tmp.classList.remove('facing-section__thumb-slide--active'));
                    slides[this.realIndex].classList.add('facing-section__thumb-slide--active');
                    thumbs.slideTo(this.realIndex);
                    thumbs.activeIndex = this.realIndex;
                    thumbs.clickedIndex = this.realIndex;
                  }
                },
              },
            };

            if (mainSlider.querySelectorAll('.swiper-slide').length === 1) {
              options.loop = false;
            }

            if (!tab.initedSwiper) {
              tab.initedSwiper = true;
              new Swiper(mainSlider, options);
            }
          },

          openFullPopup() {
            const popup = this.$el.querySelector('.popup-fullscreen');
            this.fullscreenActive = this.thumb.activeIndex;
            window.bodyLock.disableBodyScroll(popup);
            setTimeout(() => {
              this.popupFullOpen = true;
            }, 500);
          },
          changeTabByArrow(btn, index, next) {
            if (next) {
              if ((this.currentIndex + 1) === this.tabBtns.length) {
                this.currentIndex = 0;
              } else {
                this.currentIndex += 1;
              }
            } else if (!next) {
              if (this.currentIndex === 0) {
                this.currentIndex = this.tabBtns.length - 1;
              } else {
                this.currentIndex -= 1;
              }
            }
            this.activeTabButton = this.tabBtns[this.currentIndex];
            this.changeTabs(this.activeTabButton, this.currentIndex);
          },
          // toggleViewArrow(left, right) {
          //   if (this.tabBtns.length) {
          //     left.style.visibility = (this.currentIndex === 0) ? 'hidden' : 'visible';
          //     right.style.visibility = (this.currentIndex === (this.tabBtns.length - 1)) ? 'hidden' : 'visible';
          //   }
          // },
        },
      });
    });
  }
}



// WEBPACK FOOTER //
// ./bali-blocks/block-tabs/block-tabs.js